import request from "../utils/server";


//获取用户信息
export function gotUserInfo() {
    return request('/v1/user/browser/info', {
        method: 'GET',
        params:{}
    })
}

//获取套餐列表
export function getProductList() {
    return request('/v1/vip/products', {
        method: 'GET',
        params:{}
    })
}

//兑换卡密
export function handleExchangeCard(params) {
    return request('/v1/user/browser/use', {
        method: 'POST',
        data:params
    })
}

//发送验证码
export function sendingCode(params) {
    return request('/v1/auth/code', {
        method: 'POST',
        data:params
    })
}

//绑定邮箱
export function bindEmailApi(params) {
    return request('/v1/user/bind-email', {
        method: 'POST',
        data:params
    })
}
//绑定邀请人
export function bindInviterApi(params) {
    return request('/v1/user/bind-inviter', {
        method: 'POST',
        data:params
    })
}

// 免费 x 天  控制
export function freeDaysApi() {
    return request('v1/vip/free', {
        method: 'GET',
        params:{}
    })
}